import React from 'react'
import { Switch, Route, BrowserRouter } from 'react-router-dom'

import SignedInLayout from 'layouts/signedIn'

import Login from 'pages/Login'
import Home from 'pages/Home'
import Forbidden from 'pages/Forbidden'
import Collaborators from 'pages/Collaborators'
import ManualAnalysisAudit from 'pages/ManualAnalysisAudit'
import Statistics from 'pages/Statistics'

import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'

import UserManagement from 'pages/UserManagement'
import SecuredRoute from './securedRoute'
import ConfigOptions from "../pages/ConfigOptions"
import OpenRouteWithLayout from "./OpenRouteWithLayout"
import VerifyEmailSignature from "../pages/PasswordManagement/VerifyEmailSignature"
import { EmailSent, PasswordCreation, PasswordRecover, PasswordSuccess } from "../pages/PasswordManagement"
import DefaultLayout from "../layouts/Default"
import { Scopes } from "../utils/authUtils"

const withLoginRoutes = () => (<Switch>
  <Route path="/login" exact component={Login} />
  
  <SecuredRoute
    path={ROUTE_CONSTANTS.HOME}
    requiredScopes={[Scopes.ACCESS]}
    exact
    parent={SignedInLayout}
    child={Home}
  />

  <SecuredRoute
    path={ROUTE_CONSTANTS.MANUAL_ANALISYS_AUDIT}
    requiredScopes={[Scopes.ACCESS]}
    exact
    parent={SignedInLayout}
    child={ManualAnalysisAudit}
  />

  <SecuredRoute
    path={ROUTE_CONSTANTS.STATISTICS}
    requiredScopes={[Scopes.ACCESS]}
    exact
    parent={SignedInLayout}
    child={Statistics}
  />

  <SecuredRoute
    path={ROUTE_CONSTANTS.USER_MANAGEMENT}
    requiredScopes={[Scopes.USER_MANAGEMENT]}
    exact
    parent={SignedInLayout}
    child={UserManagement}
  />

<SecuredRoute
    path={ROUTE_CONSTANTS.RESTRICTED_OPTIONS}
    requiredScopes={[Scopes.OPTIONS_MANAGEMENT]}
    exact
    parent={SignedInLayout}
    child={ConfigOptions}
  />


  <SecuredRoute
    path={ROUTE_CONSTANTS.COLLABORATORS}
    requiredScopes={[Scopes.ACCESS]}
    exact
    parent={SignedInLayout}
    child={Collaborators}
  />

  <Route
    path={ROUTE_CONSTANTS.PASSWORD_RECOVER}
    exact
    component={VerifyEmailSignature}
  />

  <OpenRouteWithLayout
    parent={DefaultLayout}
    child={PasswordRecover}
    exact
    path={ROUTE_CONSTANTS.FORGOT_PASSWORD}
  />

  <SecuredRoute
    requiredScopes={[Scopes.PASSWORD_CHANGE]}
    parent={DefaultLayout}
    child={PasswordCreation}
    exact
    path={ROUTE_CONSTANTS.PASSWORD_CREATION}
  />

  <SecuredRoute
    requiredScopes={[Scopes.PASSWORD_CHANGE]}
    parent={DefaultLayout}
    child={PasswordCreation}
    exact
    path={ROUTE_CONSTANTS.PASSWORD_REDEFINE}
  />

  <OpenRouteWithLayout
    parent={DefaultLayout}
    child={EmailSent}
    exact
    path={ROUTE_CONSTANTS.EMAIL_SENT}
  />

  <OpenRouteWithLayout
    parent={DefaultLayout}
    child={PasswordSuccess}
    exact
    path={ROUTE_CONSTANTS.PASSWORD_SUCCESS}
  />

  <OpenRouteWithLayout
    parent={DefaultLayout}
    child={Forbidden}
    exact
    path={ROUTE_CONSTANTS.FORBIDDEN}
  />
</Switch>)

const withoutLoginRoutes = () => (<Switch>
  <Route
    path={ROUTE_CONSTANTS.HOME}
    exact
    component={(rest) => <SignedInLayout component={Home} {...rest} />}
  />

  <Route
    path={ROUTE_CONSTANTS.COLLABORATORS}
    exact
    component={(rest) => <SignedInLayout component={Collaborators} {...rest} />}
  />
</Switch>)

const Router = () => {
  return (<BrowserRouter>
    {process.env.REACT_APP_LOGIN_DISABLED === 'true' ? withoutLoginRoutes() : withLoginRoutes()}
  </BrowserRouter>)
}

export default Router
